/* Ræd Bundle Builder — pick-your-scents bars + ready-made Best Seller bundle,
   subtotal with savings, delivery notes. Shares its look with the Ræd Bundle
   Picker (raed-bundle-picker.css); logic adapted from raed-bundle-picker.js.

   Pricing model (v2): in each bundle the first `recurringQty` bottles renew
   monthly on the selling plan, the last `freeQty` bottles are free on the
   first order only (the store's automatic "buy N monthly, get 1 free"
   discount makes them free at checkout), anything else is a one-time bottle
   at full price. */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function setup(root) {
    var blockId = root.dataset.blockId;
    var configEl = document.getElementById('raed-bb-config-' + blockId);
    if (!configEl) return;

    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) {
      console.error('[raed-bundle-builder] invalid config JSON', e);
      return;
    }

    var subscribeRow = root.querySelector('[data-subscribe]');
    var subscribeLabelEl = root.querySelector('[data-subscribe-label]');
    var subscribeDetail = root.querySelector('[data-subscribe-detail]');
    var addBtn = root.querySelector('[data-add-btn]');
    var subtotalWas = root.querySelector('[data-subtotal-was]');
    var subtotalNow = root.querySelector('[data-subtotal-now]');
    var savingEl = root.querySelector('[data-saving]');
    var savingText = root.querySelector('[data-saving-text]');
    var renewalEl = root.querySelector('[data-renewal]');
    var notesEl = root.querySelector('[data-notes]');
    var cartDrawer = document.querySelector('cart-drawer');

    var state = {
      bundleId: null,
      subscribeChecked: false,
      slots: [],
      openSlotIndex: null,
      modal: null,
    };

    // ─── Plans & pricing ───────────────────────────────────────

    // Liquid price_adjustment values: percentage = 0-100,
    // fixed_amount and price = amount in cents.
    function applyPlanDiscount(priceCents, plan) {
      if (!plan) return priceCents;
      if (plan.discountType === 'percentage') return Math.round(priceCents * (1 - plan.discountValue / 100));
      if (plan.discountType === 'fixed_amount') return Math.max(0, priceCents - plan.discountValue);
      if (plan.discountType === 'price') return plan.discountValue;
      return priceCents;
    }

    function planSaving(plan, priceCents) {
      return priceCents - applyPlanDiscount(priceCents, plan);
    }

    // Match the selling plan by name. A plan name that matches nothing means
    // "no plan" (one-time) — never silently substitute another plan. With an
    // empty name, use the plan with the biggest discount (then the first one).
    var warnedKeys = {};
    function findPlan(product, planKey) {
      if (!product || !product.sellingPlans || !product.sellingPlans.length) return null;
      var plans = product.sellingPlans;
      if (planKey && String(planKey).trim()) {
        var key = String(planKey).trim().toLowerCase();
        for (var i = 0; i < plans.length; i++) {
          if (String(plans[i].name).toLowerCase().indexOf(key) !== -1) return plans[i];
        }
        if (!warnedKeys[key]) {
          warnedKeys[key] = true;
          console.warn('[raed-bundle-builder] no selling plan named like "' + planKey + '" on ' + product.title + ' — treating as one-time. Plans: ' + plans.map(function (sp) { return sp.name; }).join(' | '));
        }
        return null;
      }
      var best = plans[0];
      var bestSaving = planSaving(best, product.price);
      for (var j = 1; j < plans.length; j++) {
        var s = planSaving(plans[j], product.price);
        if (s > bestSaving) { best = plans[j]; bestSaving = s; }
      }
      return best;
    }

    function currentBundle() {
      for (var i = 0; i < config.bundles.length; i++) {
        if (config.bundles[i].id === state.bundleId) return config.bundles[i];
      }
      return config.bundles[0];
    }

    function slotProduct(bundle, i) {
      if (bundle.id === state.bundleId && state.slots[i]) return state.slots[i];
      return config.currentProduct;
    }

    // When the Subscribe & Save row is hidden the monthly bottles are implied
    // by the bundle itself; when it is shown the checkbox decides.
    function subActive() {
      return config.showSubscribe ? state.subscribeChecked : true;
    }

    // The bundle only "subscribes" when every recurring slot resolves a plan;
    // otherwise everything is one-time at full price (and nothing is free,
    // because the checkout discount needs the recurring bottles in the cart).
    function recurringResolved(bundle) {
      var rq = bundle.recurringQty || 0;
      for (var i = 0; i < rq; i++) {
        if (!findPlan(slotProduct(bundle, i), bundle.planKey)) return false;
      }
      return rq > 0;
    }

    // Slot roles: 'recurring' (renews on the plan), 'free' (first order only),
    // 'onetime' (full price once). Without an active subscription nothing is
    // free — the checkout discount needs the recurring bottles in the cart.
    function slotKind(bundle, i) {
      var sub = subActive() && recurringResolved(bundle);
      if (!sub) return 'onetime';
      if (i < bundle.recurringQty) return 'recurring';
      if (i >= bundle.qty - (bundle.freeQty || 0)) return 'free';
      return 'onetime';
    }

    function unitPrice(bundle, i) {
      var p = slotProduct(bundle, i);
      var kind = slotKind(bundle, i);
      if (kind === 'recurring') return applyPlanDiscount(p.price, findPlan(p, bundle.planKey));
      if (kind === 'free') return 0;
      return p.price;
    }

    // first = what the first order costs, full = value at one-time prices,
    // renewal = what renews every month for `n` bottles.
    function totals(bundle) {
      var t = { first: 0, full: 0, renewal: 0, n: 0 };
      for (var i = 0; i < bundle.qty; i++) {
        var p = slotProduct(bundle, i);
        var u = unitPrice(bundle, i);
        t.first += u;
        t.full += p.price;
        if (slotKind(bundle, i) === 'recurring') { t.renewal += u; t.n++; }
      }
      return t;
    }

    function priceHtml(cents, suffix) {
      return money(cents) +
        (suffix ? ' <span class="raed-bp__price-suffix">' + escHtml(suffix) + '</span>' : '');
    }

    function updatePrices() {
      var active = currentBundle();
      if (!active) return;

      // Bar prices: first-order total (or ÷ bottles), full value struck through
      config.bundles.forEach(function (b) {
        var bar = root.querySelector('[data-bundle="' + b.id + '"]');
        if (!bar) return;
        var t = totals(b);
        var perItem = config.priceDisplay === 'per_item' && b.qty > 1;
        var divisor = perItem ? b.qty : 1;
        var displayPrice = Math.round(t.first / divisor);
        var displayCompare = Math.round(t.full / divisor);

        var priceEl = bar.querySelector('[data-price]');
        var compareEl = bar.querySelector('[data-compare-price]');
        if (priceEl) priceEl.innerHTML = priceHtml(displayPrice, perItem ? config.perItemSuffix : '');
        if (compareEl) {
          if (t.first < t.full) {
            compareEl.textContent = money(displayCompare);
            compareEl.hidden = false;
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
          }
        }
      });

      // Row prices (only the active bar renders rows)
      root.querySelectorAll('[data-slot-price]').forEach(function (el) {
        var i = parseInt(el.dataset.slotPrice, 10);
        var kind = slotKind(active, i);
        var p = slotProduct(active, i);
        el.classList.toggle('raed-bp__slot-price--free', kind === 'free');
        if (kind === 'free') {
          el.innerHTML = '<s>' + money(p.price) + '</s> ' + escHtml(config.freeLabel || 'FREE');
        } else if (kind === 'recurring') {
          el.innerHTML = priceHtml(unitPrice(active, i), config.recurringSuffix);
        } else {
          el.innerHTML = priceHtml(unitPrice(active, i), config.perItemSuffix);
        }
      });

      // Subtotal + savings pill + renewal line
      var t = totals(active);
      if (subtotalNow) subtotalNow.textContent = money(t.first);
      if (subtotalWas) {
        if (t.first < t.full) {
          subtotalWas.textContent = money(t.full);
          subtotalWas.hidden = false;
        } else {
          subtotalWas.textContent = '';
          subtotalWas.hidden = true;
        }
      }
      if (savingEl) {
        if (t.first < t.full) {
          if (savingText) {
            savingText.textContent = String(config.savingLabel || "You're saving [amount]").replace('[amount]', money(t.full - t.first));
          }
          savingEl.hidden = false;
        } else {
          savingEl.hidden = true;
        }
      }
      if (renewalEl) {
        if (config.showRenewal && t.n > 0 && config.renewalText) {
          var txt = String(config.renewalText).replace('[amount]', money(t.renewal)).replace('[n]', String(t.n));
          if (t.n === 1) txt = txt.replace(/\bbottles\b/, 'bottle');
          renewalEl.textContent = txt;
          renewalEl.hidden = false;
        } else {
          renewalEl.hidden = true;
        }
      }

      // Subscribe row copy
      var ref = state.slots[0] || config.currentProduct;
      var plan = findPlan(ref, active.planKey);
      if (subscribeLabelEl) {
        var label = config.subscribeLabel;
        if (plan && plan.discountType === 'percentage' && plan.discountValue > 0) {
          label += ' ' + Math.round(plan.discountValue) + '%';
        }
        subscribeLabelEl.textContent = label;
      }
      if (subscribeDetail) {
        subscribeDetail.textContent = (config.showPlanName && plan) ? plan.name : '';
      }

      // Delivery notes follow the subscription state when configured so
      if (notesEl && config.notesMode === 'subscribed') notesEl.hidden = !(t.n > 0);

      if (config.syncMainPrice) syncMainPrice(t.first);
    }

    function syncMainPrice(cents) {
      var formatted = money(cents);
      document.querySelectorAll('.wt-product__price__final').forEach(function (el) {
        if (el.closest('[data-raed-bb]') || el.closest('[data-raed-bp]')) return;
        var current = parseFloat(el.textContent.replace(/[$,]/g, ''));
        if (isNaN(current) || Math.abs(current - cents / 100) > 0.005) {
          el.textContent = formatted;
        }
      });
    }

    // ─── Bundle selection & slots ──────────────────────────────

    function fillFromPool(slots, used, pool, qty) {
      for (var i = slots.length; i < qty; i++) {
        var pick = null;
        for (var j = 0; j < pool.length; j++) {
          if (pool[j] && !used[pool[j].id]) { pick = pool[j]; break; }
        }
        if (pick) used[pick.id] = true;
        slots.push(pick);
      }
      return slots;
    }

    // Pick bars: slot 0 is always this page's product; the merchant's
    // preselects fill the rest (skipping duplicates), then the catalogue.
    function buildDefaultMix(qty) {
      var used = {};
      used[config.currentProduct.id] = true;
      var pool = (config.defaultMix || []).concat(config.products || []);
      return fillFromPool([config.currentProduct], used, pool, qty);
    }

    // Preset bar: the merchant's Best Seller list, optionally led by this
    // page's product; duplicates skipped, catalogue tops up any gap.
    function buildPresetMix(qty) {
      var slots = [];
      var used = {};
      if (config.presetIncludeCurrent) {
        slots.push(config.currentProduct);
        used[config.currentProduct.id] = true;
      }
      var pool = (config.presetMix || []).concat(config.defaultMix || [], config.products || []);
      return fillFromPool(slots, used, pool, qty);
    }

    function selectBundle(id) {
      var bundle = null;
      for (var i = 0; i < config.bundles.length; i++) {
        if (config.bundles[i].id === id) bundle = config.bundles[i];
      }
      if (!bundle) bundle = config.bundles[0];
      if (!bundle) return;
      state.bundleId = bundle.id;

      state.slots = bundle.mode === 'preset' ? buildPresetMix(bundle.qty) : buildDefaultMix(bundle.qty);

      root.querySelectorAll('.raed-bp__bar').forEach(function (bar) {
        var isActive = parseInt(bar.dataset.bundle, 10) === bundle.id;
        bar.classList.toggle('raed-bp__bar--selected', isActive);
        bar.setAttribute('aria-checked', isActive ? 'true' : 'false');
        var slotsEl = bar.querySelector('[data-slots]');
        if (slotsEl && !isActive) slotsEl.innerHTML = '';
      });

      renderSlots();
      updatePrices();
    }

    function renderSlots() {
      var bundle = currentBundle();
      var bar = root.querySelector('[data-bundle="' + bundle.id + '"]');
      var container = bar && bar.querySelector('[data-slots]');
      if (!container) return;

      container.innerHTML = '';
      var preset = bundle.mode === 'preset';
      if (!preset && bundle.qty < 2 && state.slots[0]) return; // single unit: no slot list needed

      for (var i = 0; i < bundle.qty; i++) {
        var product = state.slots[i];
        var el = document.createElement('div');
        el.className = 'raed-bp__slot ' + (product ? 'raed-bp__slot--filled' : 'raed-bp__slot--empty');

        if (product) {
          var swappable = !preset && i > 0;
          if (preset) el.classList.add('raed-bp__slot--preset');
          if (swappable) {
            el.classList.add('raed-bp__slot--swappable');
            el.setAttribute('data-slot-swap', i);
            el.setAttribute('role', 'button');
            el.setAttribute('title', 'Tap to change this scent');
          }
          el.innerHTML =
            '<img class="raed-bp__slot-img" src="' + escHtml(product.image) + '" alt="" width="48" height="48" loading="lazy">' +
            '<div class="raed-bp__slot-meta">' +
              '<span class="raed-bp__slot-name">' + escHtml(product.title) + '</span>' +
              (config.showRowInspiration && product.inspiration ? '<span class="raed-bp__slot-sub">' + escHtml(product.inspiration) + '</span>' : '') +
            '</div>' +
            (config.showRowPrice ? '<span class="raed-bp__slot-price" data-slot-price="' + i + '"></span>' : '') +
            (swappable ? '<button type="button" class="raed-bp__slot-remove" data-slot-remove="' + i + '" aria-label="Remove">&times;</button>' : '');
        } else {
          el.innerHTML =
            '<div class="raed-bp__slot-plus" aria-hidden="true">+</div>' +
            '<button type="button" class="raed-bp__slot-pick" data-slot-pick="' + i + '">SELECT YOUR SCENT</button>';
        }
        container.appendChild(el);
      }
    }

    // ─── Subscribe toggle ──────────────────────────────────────

    function setSubscribe(on) {
      state.subscribeChecked = on;
      if (subscribeRow) {
        subscribeRow.classList.toggle('raed-bp__subscribe--checked', on);
        subscribeRow.setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }

    // ─── Product picker modal (built dynamically) ──────────────

    // A slot is "free" when it falls in the bundle's last freeQty positions
    // (e.g. 2 monthly + 1 free: slot 2 free). Display only — the checkout
    // discount does the actual pricing.
    function isFreeSlot(slotIndex) {
      var bundle = currentBundle();
      return !!bundle && slotKind(bundle, slotIndex) === 'free';
    }

    function modalProgressText() {
      var bundle = currentBundle();
      if (!bundle || state.openSlotIndex === null) return '';
      var total = bundle.qty - 1; // slot 0 is the main product
      if (total < 2) return '';
      return 'Scent ' + state.openSlotIndex + ' of ' + total;
    }

    function buildItemsHtml() {
      if (!config.products || !config.products.length) {
        return '<p class="raed-bp__modal-empty">No fragrances available. Check the block settings: pick a collection, or disable &ldquo;Only show products with subscription plans&rdquo;.</p>';
      }
      var freeSlot = isFreeSlot(state.openSlotIndex);
      var html = '';
      config.products.forEach(function (p) {
        var priceHtmlStr = freeSlot
          ? '<s class="raed-bp__modal-price-was">' + money(p.price) + '</s> <span class="raed-bp__modal-price-free">' + escHtml(config.freeLabel || 'FREE') + '</span>'
          : money(p.price);
        html +=
          '<div class="raed-bp__modal-item">' +
            '<img class="raed-bp__modal-img" src="' + escHtml(p.image) + '" alt="" width="56" height="56" loading="lazy">' +
            '<div class="raed-bp__modal-info">' +
              '<span class="raed-bp__modal-name">' + escHtml(p.title) + '</span>' +
              (p.inspiration ? '<span class="raed-bp__modal-sub">' + escHtml(p.inspiration) + '</span>' : '') +
              '<span class="raed-bp__modal-price">' + priceHtmlStr + '</span>' +
            '</div>' +
            '<button type="button" class="raed-bp__modal-choose" data-pick-product="' + p.id + '">Choose</button>' +
          '</div>';
      });
      return html;
    }

    function refreshModal() {
      if (!state.modal) return;
      var list = state.modal.querySelector('.raed-bp__modal-list');
      if (list) list.innerHTML = buildItemsHtml();
      var prog = state.modal.querySelector('[data-modal-progress]');
      if (prog) prog.textContent = modalProgressText();
    }

    function openModal(slotIndex) {
      state.openSlotIndex = slotIndex;
      closeModal();

      var modal = document.createElement('div');
      modal.className = 'raed-bp__modal';
      modal.setAttribute('data-rbb-modal', blockId);
      modal.style.cssText = root.getAttribute('style');

      modal.innerHTML =
        '<div class="raed-bp__modal-overlay" data-modal-close></div>' +
        '<div class="raed-bp__modal-panel" role="dialog" aria-modal="true">' +
          '<div class="raed-bp__modal-hd">' +
            '<div class="raed-bp__modal-hd-copy">' +
              '<h3 class="raed-bp__modal-title">' + escHtml(config.modalTitle) + '</h3>' +
              '<span class="raed-bp__modal-progress" data-modal-progress>' + escHtml(modalProgressText()) + '</span>' +
            '</div>' +
            '<button type="button" class="raed-bp__modal-close" data-modal-close aria-label="Close">' +
              '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 4l12 12M16 4L4 16"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="raed-bp__modal-list">' + buildItemsHtml() + '</div>' +
        '</div>';

      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-modal-close]')) { closeModal(); return; }
        var chooseBtn = e.target.closest('[data-pick-product]');
        if (chooseBtn) pickProduct(parseInt(chooseBtn.dataset.pickProduct, 10));
      });

      var anim = config.modalAnimation || 'slide';
      modal.style.setProperty('--rbp-modal-dur', (config.modalAnimSpeed || 300) + 'ms');
      if (anim !== 'none') modal.classList.add('raed-bp__modal--a-' + anim);

      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';
      state.modal = modal;
    }

    function closeModal() {
      if (!state.modal) return;
      var m = state.modal;
      state.modal = null;
      var anim = config.modalAnimation || 'slide';
      if (anim === 'none') {
        m.remove();
        document.body.style.overflow = '';
        return;
      }
      m.classList.add('raed-bp__modal--closing');
      setTimeout(function () {
        m.remove();
        document.body.style.overflow = '';
      }, config.modalAnimSpeed || 300);
    }

    function pickProduct(productId) {
      var p = null;
      for (var i = 0; i < config.products.length; i++) {
        if (config.products[i].id === productId) p = config.products[i];
      }
      if (!p || state.openSlotIndex === null) return;
      state.slots[state.openSlotIndex] = p;
      renderSlots();
      updatePrices();

      // Keep the modal open and move on to the next empty slot so multi-item
      // bundles can be filled in one go; close once the bundle is complete.
      var next = state.slots.indexOf(null);
      if (next === -1) {
        state.openSlotIndex = null;
        closeModal();
        return;
      }
      state.openSlotIndex = next;
      refreshModal();
    }

    // ─── Add to cart ───────────────────────────────────────────

    function addToCart() {
      var bundle = currentBundle();
      var items = [];

      for (var i = 0; i < bundle.qty; i++) {
        var p = state.slots[i];
        if (!p) {
          var pickBtn = root.querySelector('[data-slot-pick="' + i + '"]');
          if (pickBtn) pickBtn.focus();
          alert('Please select all your fragrances before adding to cart.');
          return;
        }
        var entry = { id: p.variantId, quantity: 1 };
        if (slotKind(bundle, i) === 'recurring') {
          var plan = findPlan(p, bundle.planKey);
          if (plan) entry.selling_plan = plan.id;
        }
        items.push(entry);
      }

      // The free bottles are priced by a Buy X get Y discount code that
      // requires the monthly bottles; apply it whenever this bundle has both.
      var hasFree = false;
      for (var f = 0; f < bundle.qty; f++) { if (slotKind(bundle, f) === 'free') hasFree = true; }
      var discountCode = (config.bundleDiscountCode && hasFree && totals(bundle).n > 0) ? String(config.bundleDiscountCode).trim() : '';

      var payload = { items: items };
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        payload.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }

      addBtn.disabled = true;
      var originalText = addBtn.textContent;
      addBtn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) throw new Error(response.description || 'Could not add to cart');
          // Attach the free-bottle code to the cart itself so it survives the
          // hand-off to checkout (and abandoned-checkout links); the checkout
          // URL parameter below is only a second safety net.
          if (!discountCode) return response;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: discountCode }),
          }).then(function () { return response; }, function () { return response; });
        })
        .then(function (response) {
          onCartSuccess(response, discountCode);
        })
        .catch(function (err) {
          alert(err.message || 'Error adding to cart. Please try again.');
        })
        .finally(function () {
          addBtn.disabled = false;
          addBtn.textContent = config.addToCartText || originalText;
        });
    }

    function onCartSuccess(response, discountCode) {
      if (config.cartBehavior === 'checkout') {
        window.location.href = '/checkout' + (discountCode ? '?discount=' + encodeURIComponent(discountCode) : '');
        return;
      }
      // Cart page / drawer: register the code on the session so checkout picks it up
      if (discountCode) {
        try {
          fetch('/discount/' + encodeURIComponent(discountCode) + '?redirect=%2F', { credentials: 'same-origin' }).catch(function () {});
        } catch (e) { /* ignore */ }
      }
      if (config.cartBehavior === 'page' || !cartDrawer) {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'raed-bundle-builder', cartData: response });
      }
      if (typeof cartDrawer.renderContents === 'function') {
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(response, true);
      }
    }

    // ─── Events ────────────────────────────────────────────────

    root.addEventListener('click', function (e) {
      var pickBtn = e.target.closest('[data-slot-pick]');
      if (pickBtn) { openModal(parseInt(pickBtn.dataset.slotPick, 10)); return; }

      var removeBtn = e.target.closest('[data-slot-remove]');
      if (removeBtn) {
        state.slots[parseInt(removeBtn.dataset.slotRemove, 10)] = null;
        renderSlots();
        updatePrices();
        return;
      }

      var swapEl = e.target.closest('[data-slot-swap]');
      if (swapEl) { openModal(parseInt(swapEl.dataset.slotSwap, 10)); return; }

      var bar = e.target.closest('.raed-bp__bar');
      if (bar) {
        var id = parseInt(bar.dataset.bundle, 10);
        if (id && id !== state.bundleId) selectBundle(id);
      }
    });

    if (subscribeRow) {
      subscribeRow.addEventListener('click', function () {
        setSubscribe(!state.subscribeChecked);
        updatePrices();
      });
      subscribeRow.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          setSubscribe(!state.subscribeChecked);
          updatePrices();
        }
      });
    }

    if (addBtn) addBtn.addEventListener('click', addToCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.modal) closeModal();
    });

    // ─── Init ──────────────────────────────────────────────────
    if (!config.bundles.length) return;
    if (config.subscribeDefault) setSubscribe(true);
    selectBundle(config.defaultBundle);
  }

  function initAll() {
    document.querySelectorAll('[data-raed-bb]').forEach(function (root) {
      if (root.dataset.rbbReady) return;
      root.dataset.rbbReady = '1';
      setup(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init after the section re-renders
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAll, 50);
  });
})();
